// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"04554c74","181":"d912a171","556":"8382d099","607":"6bcb4955","619":"bcef041c","695":"1c71eff7","756":"2a6798d3","813":"bb2d94b3","879":"2c14664c","986":"31d6cfe0"}[chunkId] + ".chunk.css";
};